import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

export class RefundPolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const existing = document.getElementById('termly-jssdk');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    document.body.appendChild(script);
  }

  render() {
    return (
      <div>
        <PageBanner title='Refund Policy' background='page-banner.jpg' />
        <div className='p-3'>
          <div
            name='termly-embed'
            data-id='895eafd1-28c5-42bd-8f46-40285c640ebe'
          ></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default RefundPolicy;
